var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00390625 0 L 15 0 L 15 13.996094 L 0.00390625 13.996094 Z M 0.00390625 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.24938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 7.228471 12.604208 C 10.293677 12.604208 12.782638 10.11971 12.782638 7.051281 C 12.782638 3.982852 10.293677 1.498354 7.228471 1.498354 C 4.163266 1.498354 1.674305 3.982852 1.674305 7.051281 C 1.674305 10.11971 4.163266 12.604208 7.228471 12.604208 Z M 7.228471 12.604208 ",
    transform: "matrix(1.125281,0,0,1.050263,-0.630158,-0.409602)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.24938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 7.228471 4.830854 L 7.228471 7.051281 ",
    transform: "matrix(1.125281,0,0,1.050263,-0.630158,-0.409602)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.24938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 7.228471 9.271708 L 7.235414 9.271708 ",
    transform: "matrix(1.125281,0,0,1.050263,-0.630158,-0.409602)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle3);
export default __webpack_public_path__ + "static/media/alert-circle 3.e8dab7d792004782ef1e4cb88035a549.svg";
export { ForwardRef as ReactComponent };